import { axiosPlacement, axiosInstanceV2 } from "./AxiosInstance";
import { invalidateCache } from "./dataCache";

const API_URL = "/users";

export const getUsers = async (limit = 10, page = 1, filters = {}) => {
  try {
    const response = await axiosPlacement.get(API_URL, {
      params: {
        ...filters,
        limit,
        page
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching users", error);
    throw error;
  }
};

export const getUser = async (id) => {
  try {
    const response = await axiosInstanceV2.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user", error);
    throw error;
  }
};

export const addUser = async (userData) => {
  try {
    const response = await axiosInstanceV2.post(API_URL, userData);
    invalidateCache('users_5000');
    return response.data;
  } catch (error) {
    console.error("Error adding user", error);
    throw error;
  }
};

export const updateUser = async (user, userId) => {
  try {
    const response = await axiosInstanceV2.put(`${API_URL}/${userId}`, user);
    invalidateCache('users_5000');
    return response.data;
  } catch (error) {
    console.error("Error updating user", error);
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const response = await axiosInstanceV2.delete(`${API_URL}/${userId}`);
    invalidateCache('users_5000');
    return response.data;
  } catch (error) {
    console.error("Error deleting user", error);
    throw error;
  }
};
